import { getMyData } from "@services/admin.fixransomware.com/client";
import { useQuery } from "@tanstack/react-query";
import { ClientKey, ClientMeKey } from "../client-key";
import { Client } from "@entities/client";
import { useContext } from "react";
import { AuthContext } from "@entities/auth/context";









export function useGetProfile(){

  const authContext = useContext(AuthContext);

  return useQuery<Client>({
    queryKey: [ClientKey, ClientMeKey],
    staleTime: 1000 * 60,
    queryFn: async () => {
      const myProfile = await getMyData();

      // set client in context so every prop can access it
      authContext.setClientAuth(myProfile);
      authContext.setIsAuthContextLoading(false);
      return getMyData()
    }
  })

}